import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import HiddenHelixPiercingImage from '../../Assets/Piercing Services/hidden helix piercing (2).png';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function HiddenHelixPiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
          <title>Hidden Helix Piercing UAE | 150-200 AED</title>
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in Hidden Helix Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          Hidden Helix Piercing 150-200 AED
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={HiddenHelixPiercingImage} alt="Hidden Helix Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>Hidden Helix Piercing</h3>

          <p>
            Discover a unique blend of subtlety and style with our professional hidden helix piercing services in the UAE, available at an affordable price range of 150–200 AED. Hidden helix piercing is a modern and elegant cartilage piercing placed discreetly along the upper ear, often tucked behind the ear fold, creating a stylish look that remains partially concealed from the front. This makes it a perfect choice for individuals who prefer a minimal yet trendy aesthetic while still expressing their individuality in a creative way. Whether you opt for a delicate stud or a small hoop, this piercing offers a refined and sophisticated appearance that enhances your overall style.
          </p>

          <p>
            At our piercing studio, safety, hygiene, and client comfort are our top priorities. Our certified professionals use sterile, single-use, high-quality equipment to perform each hidden helix piercing with precision and care. We strictly follow professional hygiene protocols to maintain a clean and sanitized environment, minimizing the risk of infection and ensuring a safe and smooth experience. Our goal is to provide a quick, efficient, and pain-minimized procedure, making it suitable for both first-time clients and those looking to add a unique touch to their ear piercing collection.
          </p>

          <p>
            Hidden helix piercing is ideal for individuals who want a discreet yet fashionable look. Its placement allows you to keep your piercing subtle for everyday settings while still showcasing it when styling your hair or wearing certain accessories. It pairs beautifully with other ear piercings such as lobe, tragus, or standard helix, allowing you to create a layered and personalized ear design. Our specialists take the time to understand your preferences and guide you in selecting the perfect placement and jewelry style to achieve your desired look.
          </p>

          <p>
            The procedure is typically completed within minutes, ensuring minimal discomfort and maximum convenience. Our team uses advanced techniques designed to reduce pain and promote faster healing, allowing you to enjoy your new piercing without unnecessary stress. We also provide high-quality, hypoallergenic starter jewelry that is safe for sensitive skin, helping to prevent irritation and ensure a comfortable healing process.
          </p>

          <p>
            Our clean, welcoming, and professional environment ensures that every client feels relaxed and confident throughout their visit. We understand that cartilage piercings can sometimes feel intimidating, especially for first-time clients, and our friendly staff is always available to answer your questions and provide reassurance. From consultation to completion, we focus on delivering a smooth and positive experience tailored to your needs.
          </p>

          <p>
            Aftercare is an essential part of maintaining your hidden helix piercing, and we provide detailed instructions to help you care for it properly. Our specialists will guide you on cleaning routines, recommended products, and precautions to avoid infection or irritation. With proper aftercare, your hidden helix piercing will heal effectively and remain a stylish and long-lasting addition to your look.
          </p>

          <p>
            Our hidden helix piercing services in the UAE combine affordability with premium quality, offering transparent pricing with no hidden charges. Booking your appointment is quick and convenient, allowing you to choose a time that fits your schedule. We aim to provide minimal waiting time and a seamless experience from start to finish.
          </p>

          <p>
            Choose our trusted hidden helix piercing services in the UAE for a safe, hygienic, and professional experience. With experienced specialists, precise techniques, and a strong focus on customer satisfaction, we help you achieve a subtle yet stylish look effortlessly. Book your hidden helix piercing appointment today and add a unique, elegant touch to your ear styling with confidence and expert care.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Hidden Helix Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default HiddenHelixPiercing;